'use client';

import { ServiceLayer } from '@packages/modules/src/ServiceLayer/ServiceLayer.client';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { customerReviewsInfoCallToActionMessages } from './CustomerReviewsInfoCallToAction.messages';
import { useCustomerReviewsTracking } from '../Tracking/useCustomerReviewsTracking/useCustomerReviewsTracking';

/**
 * CustomerReviewsInfoCallToAction button and dialog with rating information
 */
export const CustomerReviewsInfoCallToAction = () => {
  const {
    product: {
      reviews: { hintLayerId },
    },
  } = useConfig();

  const [dialogOpened, setDialogOpened] = useState(false);
  const { formatMessage } = useIntl();
  const { trackInfoDisplayOverlay } = useCustomerReviewsTracking();

  const dialogTitle = formatMessage(customerReviewsInfoCallToActionMessages.title);

  const handleDialogOpen = () => {
    trackInfoDisplayOverlay(dialogTitle);
    setDialogOpened(true);
  };
  const handleDialogClose = () => {
    setDialogOpened(false);
  };

  return (
    <>
      <Dialog isOpen={dialogOpened} title={dialogTitle} onClose={handleDialogClose}>
        <DialogHeader onClose={handleDialogClose}>{dialogTitle}</DialogHeader>
        <DialogContent>
          <ServiceLayer serviceLayerId={hintLayerId} />
        </DialogContent>
      </Dialog>
      <div
        role="button"
        tabIndex={0}
        onClick={handleDialogOpen}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleDialogOpen();
          }
        }}
        aria-label={formatMessage(customerReviewsInfoCallToActionMessages.ariaLabel)}
        className="flex h-3.5 w-3.5 cursor-pointer items-center justify-center"
      >
        <span className="icon-emp-information-circle-filled inline-block size-2" />
      </div>
    </>
  );
};
